import {
  FETCH_IP_BLOCKS_START,
  FETCH_IP_BLOCKS_SUCCESS,
  FETCH_IP_BLOCKS_ERROR,
  ADD_IP_BLOCK_START,
  ADD_IP_BLOCK_SUCCESS,
  ADD_IP_BLOCK_ERROR,
  ADD_IP_BLOCK_CLEAR,
  DELETE_IP_BLOCK_START,
  DELETE_IP_BLOCK_DONE,
} from "./actionTypes";

export const fetchIpBlocks = (params = {}) => {
  return {
    type: FETCH_IP_BLOCKS_START,
    payload: params
  };
};
export const fetchIpBlocksSuccess = (data) => {
  return {
    type: FETCH_IP_BLOCKS_SUCCESS,
    payload: data
  };
};
export const fetchIpBlocksError = (error) => {
  return {
    type: FETCH_IP_BLOCKS_ERROR,
    payload: { error }
  };
};

export const addIpBlock = (params = {}) => {
  return {
    type: ADD_IP_BLOCK_START,
    payload: params
  };
};
export const addIpBlockSuccess = (data) => {
  return {
    type: ADD_IP_BLOCK_SUCCESS,
    payload: data
  };
};
export const addIpBlockError = (error) => {
  return {
    type: ADD_IP_BLOCK_ERROR,
    payload: error && error.message || "",
  };
};
export const addIpBlockClear = (data) => {
  return {
    type: ADD_IP_BLOCK_CLEAR,
    payload: data
  };
};

export const deleteIpBlock = (params = {}) => {
  return {
    type: DELETE_IP_BLOCK_START,
    payload: params
  };
};
export const deleteIpBlockDone = (data) => {
  return {
    type: DELETE_IP_BLOCK_DONE,
    payload: data
  };
};
